import type { WorkType } from '../types'

export const WORK_TYPE_OPTIONS: { value: WorkType; label: string }[] = [
  { value: 'UI_DESIGN', label: 'UI Design' },
  { value: 'FRONTEND_DEVELOPMENT', label: 'Frontend Development' },
  { value: 'BACKEND_DEVELOPMENT', label: 'Backend Development' },
  { value: 'FRONTEND_BUG_FIX', label: 'Frontend Bug Fix' },
  { value: 'BACKEND_BUG_FIX', label: 'Backend Bug Fix' },
  { value: 'TESTING', label: 'Testing' },
  { value: 'MEETING', label: 'Project Management' },
  { value: 'OTHER', label: 'Retesting' },
]

const WORK_TYPE_LABELS: Record<WorkType, string> = {
  UI_DESIGN: 'UI Design',
  FRONTEND_DEVELOPMENT: 'Frontend Development',
  BACKEND_DEVELOPMENT: 'Backend Development',
  TESTING: 'Testing',
  FRONTEND_BUG_FIX: 'Frontend Bug Fix',
  BACKEND_BUG_FIX: 'Backend Bug Fix',
  REVIEW: 'Project Management',
  MEETING: 'Project Management',
  SUPPORT: 'Project Management',
  OTHER: 'Retesting',
}

export function formatWorkType(workType: WorkType): string {
  return WORK_TYPE_LABELS[workType] || workType.replace(/_/g, ' ')
}
